<bit-search [placeholder]="'search' | i18n" [(ngModel)]="searchText" appAutofocus />
